<template>
	<text-element
		v-model="password"
		id-key="password"
		:type="showPassword ? 'text' : 'password'"
		required
		autocomplete="current-password"
		placeholder="Password"
		:errors="errors || null"
		@keyup.enter="enterHandler"
	>
		<label
			v-if="showLabel"
			for="password"
			class="won-label-text-color mb-2 block text-sm font-medium"
		>
			Password
		</label>

		<template #inputIcon>
			<ShowPasswordTrigger
				:is-open="showPassword"
				@trigger-show="showPasswordTriggerHandler"
			/>
		</template>
	</text-element>
</template>

<script setup>
import { ref } from 'vue';
import ShowPasswordTrigger from '../utils/show-password-trigger.vue';
import TextElement from '../../forms/elements/text.vue';

const emit = defineEmits(['keyup:enter']);
defineProps({
	errors: {
		type: String,
		default: null
	},
	showLabel: {
		type: Boolean,
		default: true
	}
});

const password = defineModel();

const showPassword = ref(false);

const showPasswordTriggerHandler = () => {
	showPassword.value = !showPassword.value;
};

const enterHandler = (event) => {
	emit('keyup:enter', event);
}; 
</script>

